module.exports = __webpack_public_path__ + "static/step-7.32e8ba30.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/quickstart/dialogs/step-7.png
// module id = 2560
// module chunks = 252088872356810